import type { Logger } from '../types/Logger';

export const MockLogger: Logger = {
    captureMessage: () => {},
    captureWarning: () => {},
    captureException: () => {},
    captureDebug: () => {},
};
